import { render, staticRenderFns } from "./AddDirectInStock.vue?vue&type=template&id=0223837a&scoped=true"
import script from "./AddDirectInStock.vue?vue&type=script&lang=js"
export * from "./AddDirectInStock.vue?vue&type=script&lang=js"
import style0 from "./AddDirectInStock.vue?vue&type=style&index=0&id=0223837a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0223837a",
  null
  
)

export default component.exports